import { gql } from 'apollo-angular'

export default gql`
  mutation delete_survey_test_by_pk($id: Int!) {
    delete_survey_test(where: { id: { _eq: $id } }) {
      affected_rows
      returning {
        id
      }
    }
  }
`
